import { render, staticRenderFns } from "./defaultTextList.vue?vue&type=template&id=3dc37132&scoped=true"
import script from "./defaultTextList.vue?vue&type=script&lang=js"
export * from "./defaultTextList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc37132",
  null
  
)

export default component.exports